import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { ElearningPlayerStateType } from '@/modules/types/elearningPlayer';

export const elearningPlayerAdaptor = createEntityAdapter();

const initialState: ElearningPlayerStateType =
  elearningPlayerAdaptor.getInitialState({
    isVisibleMenu: false,
    isVisibleHelper: false,
    isVisibleResources: false,
    isVisibleQuizHelper: false,
    content: {
      elearning: undefined,
      frames: undefined,
      currentFrameId: undefined,
    },
  });

const elearningPlayerSlice = createSlice({
  name: 'elearningPlayer',
  initialState,
  reducers: {
    setContent: (state, action) => {
      state.content = action.payload.data;
    },
    toggleQuizHelper: (state) => {
      state.isVisibleQuizHelper = !state.isVisibleQuizHelper;
    },
    openQuizHelper: (state) => {
      state.isVisibleQuizHelper = true;
    },
    closeQuizHelper: (state) => {
      state.isVisibleQuizHelper = false;
    },
    toggleMenu: (state) => {
      state.isVisibleMenu = !state.isVisibleMenu;
      state.isVisibleResources = false;
      state.isVisibleHelper = false;
    },
    openMenu: (state) => {
      state.isVisibleMenu = true;
      state.isVisibleHelper = false;
      state.isVisibleResources = false;
    },
    closeMenu: (state) => {
      state.isVisibleMenu = false;
    },
    toggleResources: (state) => {
      state.isVisibleResources = !state.isVisibleResources;
      state.isVisibleMenu = false;
      state.isVisibleHelper = false;
    },
    openResources: (state) => {
      state.isVisibleResources = true;
      state.isVisibleMenu = false;
      state.isVisibleHelper = false;
    },
    closeResources: (state) => {
      state.isVisibleResources = false;
    },
    toggleHelper: (state) => {
      state.isVisibleHelper = !state.isVisibleHelper;
      state.isVisibleMenu = false;
      state.isVisibleResources = false;
    },
    openHelper: (state) => {
      state.isVisibleHelper = true;
      state.isVisibleMenu = false;
      state.isVisibleResources = false;
    },
    closeHelper: (state) => {
      state.isVisibleHelper = false;
    },

    reset: (state) => {
      state.isVisibleMenu = false;
      state.isVisibleHelper = false;
      state.isVisibleResources = false;
    },
  },
});

export const { name, actions, reducer } = elearningPlayerSlice;
